module.exports = __webpack_public_path__ + "static/media/400062_01.f2e4fe53.png";